import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { ChangeDetectionStrategy } from '@angular/core';

// PrimeNg
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from 'primeng/dynamicdialog';

// Services
import { HerramientasParaAdministradoresService } from './service/herramientas-para-administradores.service';

// Components
import { TableGenericComponent } from '@/shared/components/general/table-generic/table-generic.component';
import { IVariables } from '../botonera.interface';

@Component({
  selector: 'app-modal-herramientas-para-administradores',
  standalone: true,
  providers: [HerramientasParaAdministradoresService, DialogService],
  imports: [
    // Angular modules
    CommonModule,
    // PrimeNG modules
    TableModule,
    ButtonModule,
    // Custom components
    TableGenericComponent,
  ],
  templateUrl: './modal-herramientas-para-administradores.component.html',
  styleUrl: './modal-herramientas-para-administradores.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalHerramientasParaAdministradoresComponent implements OnInit
{
  tableService = inject(HerramientasParaAdministradoresService);
  dialogService = inject(DialogService);
  config = inject(DynamicDialogConfig);

  constructor() {}

  ngOnInit() {
    this.tableService.setHeaderTable();
  }
}
